<template>
    <div>
        <form-row title="Price Reductions" :no_border="true" class="mt-6"">
            <div class="-mt-4">
                <div v-for="(reduction, index) in price_reductions"
                    class="flex flex-col sm:flex-row sm:items-end flex-1 mt-3"
                >
                    <div class="sm:w-40">
                        <input-money
                            label="Price Reduction"
                            :name="'price_reductions[' + index + '][price]'"
                            v-model="reduction.price"
                            :read_only="read_only"
                        />
                    </div>

                    <div class="flex items-center mt-2 sm:mt-0 sm:pl-4">
                        <input-date
                            label="Date"
                            :name="'price_reductions[' + index + '][date]'"
                            v-model="reduction.date"
                            :read_only="read_only"
                        />

                        <div v-if="! read_only && ! isEmptyInitialEntry(index)"
                            class="cursor-pointer flex hover:text-red-600 items-center text-gray-400 ml-2 pt-5 px-2"
                            @click="removeReduction(index)"
                        >
                            <i class="fas fa-minus-circle"></i>
                        </div>
                    </div>
                </div>
            </div>
        </form-row>

        <button v-if="! read_only"
            type="button"
            class="flex items-center text-xs uppercase text-blue-500 hover:text-blue-600 leading-none focus:shadow-none sm:ml-46 my-4"
        >
            <span class="text-lg font-bold mr-2">+</span>

            <span class="inline-block py-2 cursor-pointer select-none"
                @click="addReduction"
            >
                {{ $t('Add another price reduction') }}
            </span>
        </button>

        <div v-else class="h-6 w-full"></div>

        <div class="border-b border-gray-400"></div>
    </div>
</template>

<script>
import DateFunctions from '../../mixins/date-functions.js';

export default {
    mixins: [
        DateFunctions,
    ],

    props: {
        listing_detail: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            price_reductions: this.listing_detail.price_reductions,
        }
    },

    methods: {
        addReduction() {
            this.price_reductions.push({ price: null, date: null })
        },
        removeReduction(index) {
            this.price_reductions.splice(index, 1);

            if (this.price_reductions.length == 0) {
                this.addReduction();
            }
        },
        isEmptyInitialEntry(index) {
            return index === 0
                && ! this.price_reductions[0].price
                && ! this.isValidDate(this.price_reductions[0].date);
        },
    },

    created() {
        if (this.price_reductions.length == 0) {
            this.addReduction();
        }
    },
}
</script>
